import React from 'react';
import { Box, Typography, Link, IconButton, ListItem } from '@mui/material';
import Grid from '@mui/material/GridLegacy'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import logo from "../../assets/image/getmentor.png";
import { NavLink } from 'react-router-dom';
const Footer = () => {
    return (
        <Box sx={{ backgroundColor: '#608f8f', color: 'white', p: 5 }}>
            <Grid container spacing={5}>
                {/* Logo & Description */}
                <Grid item xs={12} md={5}>
                    <ListItem sx={{ display: "grid" }}>
                        <Box
                            component="img"
                            sx={{
                                width: "45%", // Adjust the width as needed 
                                display: 'block', // Ensures the image takes up space properly
                                margin: '0 auto', // Centers the image horizontally
                            }}
                            src={logo}
                            alt="Edgology Logo"
                        />
                        <Typography variant='h5' sx={{ fontWeight: "bold" }}> GET Mentors – Celebrate Real Guidance</Typography>
                        <Typography variant="body2" mt={1}>
                            Studying abroad is a big step—you shouldn’t have to do it alone. At GET Mentors, real students share real experiences to guide you through every stage, without bias or sales pressure.
                            No agents. No jargon. Just honest support from someone who's been there.
                            Because your journey deserves more than a brochure</Typography>
                    </ListItem>
                </Grid>

                {/* Navigation Links */}
                <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Navigation</Typography>
                    <Box mt={1}>
                        {[
                            { label: 'Home', path: '/' },
                            { label: 'Meet Our Mentor', path: '/mentors' },
                            { label: 'About Us', path: '/about' },
                            { label: 'Contact Us', path: '/query' }
                        ].map((item) => (
                            <Box key={item.label} mb={2}>
                                <NavLink
                                    to={item.path}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Typography variant="body2">{item.label}</Typography>
                                </NavLink>
                            </Box>
                        ))}
                    </Box>
                </Grid>

                {/* Quick Links */}
                <Grid item xs={12} md={3} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Quick Link</Typography>
                    <Box mt={1}>
                        {[
                            { label: 'Sign In', path: '/login' },
                            { label: 'Create Account', path: '/registration' },
                            { label: 'Forget Password', path: '/forget-password' },
                            { label: 'Terms & Condition', path: '/termsandcondition' }
                        ].map((item) => (
                            <Box key={item.label} mb={2}>
                                <NavLink
                                    to={item.path}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Typography variant="body2">{item.label}</Typography>
                                </NavLink>
                            </Box>
                        ))}
                    </Box>
                    
                </Grid>


                <Grid item xs={12} md={2}>
                    {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Services</Typography>
                    <Box mt={1}>
                        {['Home', 'Contact', 'Blog', '404'].map((item) => (
                            <Typography key={item} variant="body2">{item}</Typography>
                        ))}
                    </Box> */}


                </Grid>
            </Grid>

            {/* Bottom Footer */}
            <Box mt={5} textAlign="center" borderTop="1px solid rgba(255,255,255,0.2)" pt={2}>
                <Box display="flex" justifyContent="center" mt={2}>
                        <IconButton
                            sx={{ color: 'white' }}
                            component="a"
                            href="https://www.linkedin.com/in/global-education-72782423b/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <LinkedInIcon />
                        </IconButton>
                        <IconButton
                            sx={{ color: 'white' }}
                            component="a"
                            href="https://wa.me/+918920223385"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <WhatsAppIcon />
                        </IconButton>
                        <IconButton
                            sx={{ color: 'white' }}
                            component="a"
                            href="mailto:admissionsexpert@globaleducationtalent.com"
                        >
                            <EmailIcon />
                        </IconButton>
                    </Box>
                <Typography variant="body2">
                    © 2025 GetMentor • All Rights Reserved
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
